import { el } from '../core/dom.js';
import { navigate } from '../router.js';

export function renderWelcome(parent: HTMLElement) {
  const wrap = el('div', { class: 'wizard center spaced', attrs: { style: 'padding-top:10vh;' } },
    el('div', { attrs: { style: 'display:flex; justify-content:center; margin-bottom:1.5rem;' } },
      el('div', {
        attrs: {
          style: 'width:84px; height:84px; border-radius:50%; background:var(--accent-grad); box-shadow:0 0 60px rgba(94,234,212,0.45), inset 0 0 20px rgba(255,255,255,0.2);'
        }
      })
    ),
    el('h1', { class: 'title-xl' }, 'Reduce at your pace.'),
    el('p', { class: 'lead text-muted' },
      'Wean creates space between urge and action. No shame, no all-or-nothing pressure, no account required.'),
    el('p', { class: 'text-muted', attrs: { style: 'font-size:0.9rem;' } },
      'Your plan stays on this device. No servers, no analytics, no signup. Export a backup any time.'),
    el('div', { class: 'stack', attrs: { style: 'margin-top:var(--space-5);' } },
      el('button', { class: 'btn primary block', onclick: () => navigate('/onboard') }, 'Start my plan'),
      el('button', {
        class: 'btn urge block',
        onclick: () => navigate('/rescue'),
      }, 'I need help with an urge right now'),
    ),
    el('p', { class: 'muted-sm', attrs: { style: 'margin-top:var(--space-3);' } },
      'Rescue works before you finish setup.'),
  );
  parent.appendChild(wrap);
}
